export enum UiType {
    MAP = 'Map',
    BARCHART = 'BarChart',
    BARCHART2 = 'BarChart2',
    FLOWMAP = 'FlowMap',
    DIFFMAP = 'DiffMap',
    NETMAP = 'MapBarChart',
    CHARTMAP = '10',
}
